import React, { FC, useContext, useMemo, forwardRef } from "react";
import IConfigurationContext from "../../../infrastructure/context/configuration/configuration.context.interface";
import ConfigurationContext from "../../../infrastructure/context/configuration/configuration.context";
import {
  MandatoryConsentCheckboxes,
  TranslationKeys,
} from "../../../infrastructure/const";
import ITranslationsContext from "../../../infrastructure/context/translations/translations-context.interface";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../../infrastructure/translation-manager";
import MandatoryCheckboxesSection from "../../common/mandatory-checkboxes/mandatory-checkboxes-section";

export type RegulationsCheckboxProps = {
  id: string;
  labelHtml: string;
  additionalClassName?: string;
};

export type Props = {
  displayValidationMessages: boolean;
  checkboxesRef: React.RefObject<any>;
};

const TermsAndConditionsCheckboxes: FC<Props> = forwardRef(
  ({ displayValidationMessages, checkboxesRef }, ref) => {
    const configurationContext =
      useContext<IConfigurationContext>(ConfigurationContext);
    const translationsContext =
      useContext<ITranslationsContext>(TranslationsContext);
    const translationManager = new TranslationManager(translationsContext);

    const regulationsCheckboxes: RegulationsCheckboxProps[] = useMemo(() => {
      const hidePricesAndPayment = configurationContext.isFeatureFlagEnabled(
        "hidePricesAndPayment"
      );
      let checkboxes: RegulationsCheckboxProps[] = [];

      checkboxes.push({
        id: MandatoryConsentCheckboxes.TermsAndConditions,
        labelHtml: translationManager.getTranslation(
          TranslationKeys.CHECKOUT_TERMSANDCONDITIONS_CHECKBOX
        ),
        additionalClassName: hidePricesAndPayment
          ? "termsAndConditionsCheckbox--no-margin"
          : "",
      });

      if (configurationContext.isFeatureFlagEnabled("showPrivacyPolicyConsent")) {
        checkboxes.push({
          id: MandatoryConsentCheckboxes.PrivacyPolicy,
          labelHtml: translationManager.getTranslation(
            TranslationKeys.CHECKOUT_CONSENTCHECKBOX_ACCEPTPRIVACYPOLICY
          ),
        });
      }

      return checkboxes;
    }, [configurationContext, translationManager]);

    return (
      <MandatoryCheckboxesSection
        ref={checkboxesRef}
        checkboxes={regulationsCheckboxes}
        displayValidationMessages={displayValidationMessages}
      />
    );
  }
);

export default TermsAndConditionsCheckboxes;
